import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { AIButtonContainedGrey } from '../../../AIButton'
import { BUTTON_HEIGHT_32 } from '../../../Button'
import { QA_NAME_GRETA_AI_CHAT_FEEDBACK_REASON } from '../GretaAIChatFeedbackForm.constants'

import * as styles from './GretaAIChatFeedbackReason.module.css'

function GretaAIChatFeedbackReason({ isSelected, reason, onSelect }) {
  const { t } = useTranslation()

  function handleSelect() {
    onSelect(isSelected ? null : reason.id)
  }

  return (
    <AIButtonContainedGrey
      className={classNames(styles.reason, {
        [styles.reasonSelected]: isSelected,
      })}
      height={BUTTON_HEIGHT_32}
      qaName={QA_NAME_GRETA_AI_CHAT_FEEDBACK_REASON}
      text={t(reason.textKey)}
      onClick={handleSelect}
    />
  )
}

export default GretaAIChatFeedbackReason
